import React, { useState } from "react";

interface TableDropDownSmallProps {
  /** مقدار فعلی صفحه‌بندی؛ همیشه از state واقعی جدول خوانده می‌شود، نه یک مقدار اولیه ثابت. */
  value: number;
  onSelect: (value: number) => void;
  options?: number[];
}

const TableDropDownSmall: React.FC<TableDropDownSmallProps> = ({
  value,
  onSelect,
  options = [5, 10, 20, 30, 50, 100],
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleSelect = (next: number) => {
    setIsOpen(false);
    if (next !== value) onSelect(next);
  };

  return (
    <div className="relative inline-block text-right">
      <div
        className={`block w-full px-6 py-2 text-sm bg-gray-100 text-gray-700 border border-gray-300 rounded-lg shadow-sm ${
          isOpen ? "ring-2 ring-blue-500" : "focus:ring-2 focus:ring-blue-500"
        } focus:outline-none dark:bg-gray-800 dark:text-white dark:border-gray-600 hover:bg-gray-200 transition-all duration-300 cursor-pointer`}
        onClick={() => setIsOpen((prev) => !prev)}
      >
        {value}
      </div>
      {isOpen && (
        <div
          className="absolute z-50 mt-2 w-full bg-white border border-gray-300 rounded-lg shadow-lg dark:bg-gray-800 dark:border-gray-600"
          dir="rtl"
        >
          {options.map((option) => (
            <div
              key={option}
              onClick={() => handleSelect(option)}
              className={`px-4 py-2 text-sm cursor-pointer border-b border-gray-300 last:border-none dark:hover:bg-gray-700 hover:bg-gray-200 ${
                option === value
                  ? "text-custom-600 dark:text-custom-400 font-semibold"
                  : "text-gray-700 dark:text-white"
              }`}
            >
              {option}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default TableDropDownSmall;
